export function AipLogo({ class: className, href }: { class?: string; href?: string }) {
  const content = (
    <span class={`inline-flex items-center ${className || ''}`}>
      <img src="/icons/mirasee-logo.png" alt="Mirasee" style="height: 28px; width: auto" />
    </span>
  );

  if (href) {
    return (
      <a href={href} class="no-underline">
        {content}
      </a>
    );
  }

  return content;
}
